// extracted by mini-css-extract-plugin
export default {"container":"l3RHLTu5zCR9dK9CmLGT-style-container"};